




























































































import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import axios from 'axios';

import { Translate } from '@/lang/Translator';
import { gaSend } from '@/common/googleAnalytics';

import 'formdata-polyfill';

import * as log from 'loglevel';

log.setLevel(0);

interface IFormError {
  key: string;
  message: string;
}

interface IRegisterForm {
  email: string;
  fname: string;
  lname: string;
  message: string;
  accountType: string;
  nsrv?: string;
  phone?: string;
}

@Component({})
export default class Screencast extends Vue {
  // props
  @Prop(Boolean) private withPhone: boolean;
  @Prop({ default: false }) private isCallMeBack: boolean;

  // data
  private errorList: IFormError[] = [];
  private sendingForm: boolean = false;

  // computed
  get t(): Translate {
    return this.$store.state.t;
  }
  get languageApp(): string {
    return this.$store.state.lang;
  }
  get isGlobalVersion(): boolean {
    return Boolean(this.$store.state.isGlobal);
  }
  get withCompanySize(): boolean {
    if (this.languageApp === 'en' && !this.isGlobalVersion) {
      return true;
    }

    return false;
  }
  get requiredFields(): string[] {
    const fields = [
      'fname',
      'lname',
      'email',
      'message',
    ];

    if (this.withCompanySize) {
      fields.push('nsrv');
    }

    if (this.withPhone) {
      fields.push('phone');
    }

    return fields;
  }

  get errorMessage(): string {
    if (this.errorList.length > 0) {
      return this.errorList[0].message;
    }

    return '';
  }
  get hasErrors(): boolean {
    return this.errorList.length === 0;
  }

  get submitButtonCaption(): string {
    let caption = this.t.text('question-form-submit-btn');
    if (this.languageApp === 'en' && this.isCallMeBack) {
      caption = 'Call Me Back';
    }
    return caption;
  }

  // methods
  private addError(key: string, message: string) {
    this.errorList.push({ key, message });
  }

  private async validate(formObject: any): Promise<boolean> {
    for (const key of this.requiredFields) {
      if (formObject[key] === undefined || formObject[key].trim() === '') {
        let label = '';
        switch (key) {
          case 'email':
            label = 'Email';
            break;
          case 'nsrv':
            label = 'Number of Employees';
            break;
          case 'fname':
            label = 'First Name';
            break;
          case 'lname':
            label = 'Last Name';
            break;
          case 'message':
            label = 'Message';
            break;
          case 'phone':
            label = 'Phone Number';
            break;

          default:
            break;
        }

        this.addError(key, `${label} cannot be blank`);
      }
    }

    const promiseArr: Array<Promise<any>> = [];

    const emailValid = this.checkBusinessEmail(formObject.email);
    promiseArr.push(emailValid);

    if (this.withPhone) {
      const phoneValid = this.checkPhoneNumber(formObject.phone);
      promiseArr.push(phoneValid);
    }

    await Promise.all(promiseArr).then((results) => {
      if (results[0] === false) {
        this.addError('email', this.t.text('question-form-invalidate-email'));
      }

      if (results[1] === false) {
        this.addError('phone', this.t.text('question-form-invalidate-phone'));
      }
    });

    return this.hasErrors;
  }
  private async checkPhoneNumber(phone: string): Promise<boolean> {
    const formData = new FormData();
    formData.append('init', 'DiteUla3LANDW');
    formData.append('phone', phone);

    return axios({
      method: 'POST',
      url: process.env.VUE_APP_CLIENT_CHECK_PHONE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    })
      .then((response) => {
        const resData = response.data;
        return Boolean(resData.isValid);
      })
      .catch(() => {
        return false;
      });
  }
  private async checkBusinessEmail(email: string): Promise<boolean> {
    const formData = new FormData();
    formData.append('init', 'DiteUla3LANDW');
    formData.append('email', email);

    return axios({
      method: 'POST',
      url: process.env.VUE_APP_CLIENT_CHECK_EMAIL_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    })
      .then((response) => {
        const resData = response.data;
        return Boolean(resData.isValidEmail);
      })
      .catch((e: ErrorEvent) => {
        return false;
      });
  }
  private async submitRequestForm(e: Event): Promise<void> {
    if (e.target instanceof HTMLFormElement) {
      this.sendingForm = true;

      const form = e.target;
      const formData = new FormData(form);

      // @todo add type
      const entries: any = {};
      for (const pair of formData.entries()) {
        entries[pair[0]] = pair[1];
      }

      this.errorList = [];

      const isFormValid = await this.validate(entries);
      this.sendingForm = false;
      if (isFormValid) {
        await this.createQuestionLead(entries);
        this.sendingForm = false;

        // emit for show TYP
        this.$emit('show-typ-slide', entries);
      }
    } else {
      log.error('submitRequestForm: form is not found');
    }
  }
  private createQuestionLead(clientData: IRegisterForm): Promise<any> {
    const displayName = this.isCallMeBack ? 'Call me back - Live Chat' : 'Live Chat';

    const leadData: { [propName: string]: string } = {
      init: 'DiteUla3LANDW',
      email: clientData.email,
      fname: clientData.fname,
      lname: clientData.lname,
      leadType: 'Question',
      product_code: 'none',
      leadWebsource: 'chat',
      lead_description: clientData.message,
      displayName,
    };

    if (clientData.nsrv) {
      leadData.nsrv = clientData.nsrv;
    }

    if (clientData.phone) {
      leadData.phone = clientData.phone;
    }

    if (clientData.accountType) {
      leadData.AccountType = clientData.accountType;
    }

    const formData = new FormData();
    const keys = Object.keys(leadData);
    keys.forEach((key) => formData.set(key, leadData[key]));

    return axios({
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      url: process.env.VUE_APP_OPERATOR_CREATE_LEAD_URL,
      data: formData,
    })
      .then((data: any) => {
        gaSend('Question - Livechat', window.location.pathname);
        // log.info('res', data);
      })
      .catch((e: Error) => log.error(e));
  }
}
